import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthHeader } from '../utils/auth';
import { isEnglishOperatorMode } from "../utils/operatorMode";

const API_URL = "https://salesbreaker.jp";

const PaymentSuccessPage = () => {
    const navigate = useNavigate();
    const isEnglishBeta = isEnglishOperatorMode();

    // ユーザー情報を再取得してlocalStorageを更新する関数
    const refreshUserInfo = useCallback(async () => {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (!userInfo || !userInfo.id) return;

        try {
            // /api/users は client_id でユーザーを絞り込むため、ここではidを直接使ってユーザー情報を取得する想定
            // もしそのようなAPIがなければ、/api/login を再度叩くか、専用APIをバックエンドに作る必要があります。
            // ここでは、ログイン中のユーザー情報を返す /api/me のようなAPIがあると仮定します。
            // もし /api/me がなければ、/api/users?id=${userInfo.id} のようなAPIをバックエンドに実装する必要があります。
            // 今回は、既存の/api/usersを利用し、自分の情報だけをフィルタリングします。
            const res = await fetch(`${API_URL}/api/users?id=${userInfo.id}`, {
                headers: getAuthHeader(),
            });
            const data = await res.json();
            if (data.success && data.users && data.users.length > 0) {
                localStorage.setItem('userInfo', JSON.stringify(data.users[0]));
                console.log('ユーザー情報を更新しました。');
            }
        } catch (error) {
            console.error('ユーザー情報の更新に失敗しました:', error);
        }
    }, []);

    useEffect(() => {
        refreshUserInfo(); // ユーザー情報を更新
        const timer = setTimeout(() => {
            navigate('/mypage', { replace: true });
        }, 10000); 

        return () => clearTimeout(timer); 
    }, [navigate, refreshUserInfo]);

    return (
        <div className="bg-slate-50 flex items-center justify-center min-h-screen p-4">
            <div className="w-full max-w-2xl mx-auto px-0 sm:px-6 py-8 sm:py-12 text-center">
                <div className="bg-white p-6 sm:p-12 rounded-2xl shadow-xl">
                    <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
                        <svg className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                        </svg>
                    </div>
                    <h1 className="mt-6 text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
                        {isEnglishBeta ? "Plan confirmed" : "ご登録ありがとうございます"}
                    </h1>
                    <p className="mt-4 text-base text-slate-600">
                        {isEnglishBeta ? (
                            <>
                                Your checkout was completed successfully.
                                <br />
                                You will be redirected to the English Operator dashboard in 10 seconds.
                            </>
                        ) : (
                            <>
                                決済が正常に完了しました。
                                <br />
                                10秒後に自動でマイページへ移動します。
                            </>
                        )}
                    </p>
                    <div className="mt-8">
                        <div className="w-full bg-gray-200 rounded-full h-2.5">
                            <div className="bg-indigo-600 h-2.5 rounded-full animate-progress"></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* プログレスバーのアニメーション用スタイル */}
            <style>
                {`
                @keyframes progress-bar {
                    from { width: 0%; }
                    to { width: 100%; }
                }
                .animate-progress {
                    animation: progress-bar 10s linear forwards;
                }
                `}
            </style>
        </div>
    );
};

export default PaymentSuccessPage;
